import { Injector } from '@angular/core';
import { pull } from '@sama/micro-dash';
import { InjectableSuperclass } from '@sama/ng-core';
import { MessagingService } from '../../cross-team-shared/messaging/messaging.service';
import { messageAlreadyShown } from '../../cross-team-shared/messaging/misc';
import { RollbarService } from '../../cross-team-shared/messaging/rollbar.service';
import { whenAll } from '../misc-utilities/promise-utils';

type Callback = () => Promise<boolean>;

export class AbstractCallbackService extends InjectableSuperclass {
  protected messagingService: MessagingService;
  protected rollbarService: RollbarService;

  private callbacks: Callback[] = [];

  constructor(injector: Injector) {
    super();
    this.messagingService = injector.get(MessagingService);
    this.rollbarService = injector.get(RollbarService);
  }

  addCallback(callback: Callback, injectable: InjectableSuperclass) {
    this.callbacks.push(callback);
    this.subscribeTo(injectable.destruction$, () => {
      pull(this.callbacks, callback);
    });
  }

  protected runCallbacks() {
    const promises = this.startCallbacksAndReturnPromises();
    if (promises.length > 0) {
      return this.runAsyncCallbacks(promises);
    } else {
      return undefined;
    }
  }

  private async runAsyncCallbacks(promises: Array<Promise<any>>) {
    try {
      return await whenAll(promises);
    } catch (error: any) {
      return this.handlerError(error.failures);
    }
  }

  private startCallbacksAndReturnPromises() {
    const promises: Array<Promise<unknown>> = [];
    for (const callback of this.callbacks) {
      const result = callback();
      // fix me if you change this code
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
      if (result) {
        promises.push(result);
      }
    }
    return promises;
  }

  private handlerError(failures: any[]) {
    if (!failures.includes(messageAlreadyShown)) {
      this.messagingService.showGenericError();
      this.rollbarService.error(failures);
    }
    return Promise.reject(undefined);
  }
}
